export function encryptKey (fullKey: string): string {
    return fullKey.slice(0, 7) + "•".repeat(fullKey.length - 6);
  };
